var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTime = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M8 2.6A5.4 5.4 0 1 1 8 13.4 5.4 5.4 0 0 1 8 2.6m0 .8a4.6 4.6 0 1 0 0 9.2 4.6 4.6 0 0 0 0-9.2m0 1.914c.22 0 .4.18.4.4V7.84l1.575 1.597a.4.4 0 0 1-.57.561l-1.69-1.713a.4.4 0 0 1-.115-.281V5.715c0-.221.18-.4.4-.4"
})));
export default SvgTime;